import React from "react";
import config from "../../config";
import NetplayDepositConfirm from "../../components/client/netplay/deposit/confirm";

/** Eager client bundle: avoids nested `React.lazy` + extra chunk on `/deposit/confirm`. */
const CONFIRM_BY_CLIENT: Record<string, React.ComponentType> = {
	netplay: NetplayDepositConfirm,
};

const DepositConfirm: React.FC = () => {
	const Page = CONFIRM_BY_CLIENT[config.client] ?? CONFIRM_BY_CLIENT.netplay;
	return <Page />;
};

export default DepositConfirm;
